import { cloneDeep, merge } from 'lodash';
import { getUUID } from '@/utils/grocer';

const BASE_FIELD_DATA = {
    id: undefined, // 字段的唯一值
    // fieldId: undefined, // 字段的唯一值
    type: 'text', // 字段类型
    name: '文本', // 表单中显示的label
    icon: '&#xe654;', // 图标
    formField: undefined, // 表单数据对象中的key
    options: { // 字段配置项
        config: {
            type: 'input', // 字段子类型
            options: [] // 字段预选值。如：select，radio，checkbox等
        },
        // defaultSetting: { // 字段默认配置
        //     value: '' // 字段默认值
        // },
        defaultValue: undefined,
        description: '',
        required: false, // 字段是否必填
        unique: false
    }
};

/** 文本框 */
export const getTextField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        // fieldId: uuid,
        id: uuid,
        type: 'text',
        name: '文本',
        label: '文本',
        formField: `text_${uuid}`,
        options: {
            config: {
                type: 'input'
            },
            defaultValue: '',
            unique: false
            // defaultSetting: {
            //     value: '输入框默认值'
            // }
        }
    });
};

/** 数字框 */
export const getNumberField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        // fieldId: uuid,
        id: uuid,
        type: 'number',
        name: '数字',
        label: '数字',
        formField: `number_${uuid}`,
        options: {
            config: {
                type: 'number'
            },
            defaultValue: '',
            unique: false,
            numVal: '',
            numColor: ''
            // defaultSetting: {
            //     value: '输入框默认值'
            // }
        }
    });
};

/** 计算框 */
export const getCalculationField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        // fieldId: uuid,
        id: uuid,
        type: 'calculation',
        name: '计算',
        label: '计算',
        formField: `calculation_${uuid}`,
        options: {
            config: {
                type: 'input'
            },
            defaultValue: '',
            unique: false,
            numVal: '',
            numColor: ''
            // defaultSetting: {
            //     value: '输入框默认值'
            // }
        }
    });
};

/** 日期框 */
export const getDateField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'date',
        name: '日期',
        label: '日期',
        formField: `date_${uuid}`,
        options: {
            config: {
                type: 'date'
            },
            defaultValue: '',
            unique: false
        }
    });
};

/** 选项 */
export const getCategoryField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'category',
        name: '选项',
        label: '选项',
        formField: `category_${uuid}`,
        options: {
            config: {
                type: 'single',
                options: []
            },
            unique: false
        }
    });
};

/** 下拉 */
export const getSelectField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'select',
        name: '下拉',
        label: '下拉',
        formField: `select_${uuid}`,
        options: {
            config: {
                type: 'single',
                options: []
            },
            unique: false
        }
    });
};

/** 附件 */
export const getFileField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'file',
        name: '附件',
        label: '附件',
        formField: `file_${uuid}`,
        options: {
            config: {
                type: 'file',
                options: []
            },
            unique: false
        }
    });
};

/**
 * 关联数据
 */
export const getLinkField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        type: 'link',
        name: '关联数据',
        label: '关联数据',
        formField: `link_${uuid}`,
        options: {
            config: {
                type: 'link',
                form: {
                    formId: '',
                    modelId: '',
                    selectFormFields: ''
                },
                options: []
            },
            defaultValue: '选择数据',
            unique: false
        }
    });
};

/** 子表单 */
export const getSubformField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        type: 'subform',
        name: '子表单',
        label: '子表单',
        formField: `subform_${uuid}`,
        options: {
            fieldList: [] // 子表单的表单属性列表
        }
    });
};

/** 用户 */
export const getUserField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'user',
        name: '用户',
        label: '用户',
        formField: `user_${uuid}`,
        options: {
            config: {
                type: 'single',
                options: []
            },
            unique: false
        }
    });
};

/** 部门 */
export const getDepartmentField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'department',
        name: '部门',
        label: '部门',
        formField: `department_${uuid}`,
        options: {
            config: {
                type: 'single',
                options: []
            },
            defaultValue: '',
            unique: false
        }
    });
};

/** 数据字典 */
export const getDictionaryField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'dictionary',
        name: '数据字典',
        label: '数据字典',
        formField: `dictionary_${uuid}`,
        options: {
            config: {
                type: 'single',
                options: []
            },
            unique: false
            // defaultValue: ''
        }
    });
};

/** 流水号 */
export const getSerialNumberField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'serialNumber',
        name: '流水号',
        label: '流水号',
        formField: `serialNumber_${uuid}`,
        options: {
            config: {
                type: 'single',
                options: []
            },
            defaultValue: '',
            unique: false,
            ext3: ''
        }
    });
};

/** 业务分类 */
export const getBusinessTreeField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'businessTree',
        name: '业务分类',
        label: '业务分类',
        formField: `businessTree_${uuid}`,
        options: {
            config: {
                type: 'single',
                options: []
            },
            unique: false
        }
    });
};

/** 流程 */
export const getProcessField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'process',
        name: '所属流程',
        label: '所属流程',
        formField: `process_${uuid}`,
        options: {
            config: {
                type: 'single',
                options: []
            },
            unique: false
        }
    });
};

/** 分割线 */
export const getDividerField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'divider',
        name: '分割线',
        label: '分割线',
        formField: `divider_${uuid}`,
        options: {
            config: {
                type: 'single',
                options: []
            },
            unique: true // 默认单行显示
        }
    });
};

/** 子表单汇总字段 */
export const getSubFormSummaryField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        // fieldId: uuid,
        id: uuid,
        type: 'subFormSummary',
        name: '子表计算统计',
        label: '子表计算统计',
        formField: `subFormSummary_${uuid}`,
        options: {
            config: {
                type: 'input'
            },
            defaultValue: '',
            unique: true // 默认单行显示
        }
    });
};

/** 地址 */
export const getAddrField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'address',
        name: '地址',
        label: '地址',
        formField: `address_${uuid}`,
        options: {
            config: {
                type: 'address'
            },
            unique: false
        }
    });
};

/** 级联 */
export const getCascaderField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        // fieldId: uuid,
        type: 'cascader',
        name: '级联',
        label: '级联',
        formField: `acascader_${uuid}`,
        options: {
            config: {
                type: 'single',
                options: []
            },
            unique: false
        }
    });
};

/** 档案文件 */
export const getArchiveField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        type: 'archive',
        name: '档案文件',
        label: '档案文件',
        formField: `archive_${uuid}`,
        options: {
            config: {
                type: 'archive',
                options: []
            },
            unique: false
        }
    });
};

/** 定位 */
export const getLocationField = () => {
    let uuid = getUUID(16, 16);
    return merge(cloneDeep(BASE_FIELD_DATA), {
        id: uuid,
        type: 'location',
        name: '定位',
        label: '定位',
        formField: `location_${uuid}`,
        options: {
            config: {
                type: 'location',
                options: []
            },
            unique: false
        }
    });
};

/** 获取自定义字段类型对应的名称 */
export const getFieldLabel = (type) => {
    if (type === 'text') {
        return '文本';
    } else if (type === 'number') {
        return '数字';
    } else if (type === 'calculation') {
        return '计算';
    } else if (type === 'date') {
        return '日期';
    } else if (type === 'category') {
        return '选项';
    } else if (type === 'select') {
        return '下拉';
    } else if (type === 'file') {
        return '附件';
    } else if (type === 'link') {
        return '关联数据';
    } else if (type === 'subform') {
        return '子表单';
    } else if (type === 'user') {
        return '用户';
    } else if (type === 'department') {
        return '部门';
    } else if (type === 'dictionary') {
        return '数据字典';
    } else if (type === 'serialNumber') {
        return '流水号';
    } else if (type === 'businessTree') {
        return '业务分类';
    } else if (type === 'process') {
        return '所属流程';
    } else if (type === 'divider') {
        return '分割线';
    } else if (type === 'subFormSummary') {
        return '子表计算统计';
    } else if (type === 'address') {
        return '地址';
    } else if (type === 'cascader') {
        return '级联';
    } else if (type === 'archive') {
        return '档案文件';
    } else if (type === 'location') {
        return '定位';
    }
};



// WEBPACK FOOTER //
// ./src/components/CustomForm/formBaseField.js